export default "__VITE_ASSET__4bb40499__"